import { Component, Input, OnInit } from '@angular/core';
import { HomepageService } from 'src/app/shared/services/homepage/homepage.service';
import { UtilService, VariablesService, VwoService } from 'src/app/shared/services';

@Component({
  selector: 'app-trending-fundraiers',
  templateUrl: './trending-fundraiers.component.html',
  styleUrls: ['./trending-fundraiers.component.scss']
})
export class TrendingFundraiersComponent implements OnInit {
  breakpoints = {
    600: { perView: 1.1, showArrows: false, gap: 15 },
    992: { perView: 2, focusAt: 0 }
  };
  trendingFr = [];
  currency;
  widgetsInView;
  @Input() freqVisitedCampaigns: number[] = [];
  constructor(
    private homepageService: HomepageService,
    public util: UtilService,
    public vars: VariablesService,
    public vwo: VwoService
  ) {}

  ngOnInit() {
    if (this.util.isBrowser) {
      this.getCurrency();
    } else {
      this.trendingFr = [];
    }
  }

  getTrendingFr(currency) {
    this.trendingFr = [];
    const qparams = '&with=basicInfo';
    this.homepageService
      .getTrendingFR(currency, qparams)
      .subscribe((res: any) => {
        this.trendingFr = res.data.data;
        this.trendingFr.splice(2, 0, { add: 'hf' }).join();
      });
  }

  /**
   * Get the currency of the from
   * currency observable
   */
  getCurrency() {
    this.util.currency.subscribe((res) => {
      if (res) {
        this.currency = res;
        if (this.freqVisitedCampaigns?.length) {
          this.getFreqVisitedCampaigns(res);
        } else {
          this.getTrendingFr(res);
        }
      }
    });
  }

  getFreqVisitedCampaigns(currency) {
    const qparams = '&with=basicInfo';
    this.homepageService.getFrequentVisitedCampaigns(currency, this.freqVisitedCampaigns, qparams).subscribe((res: any) => {
      this.trendingFr = res?.data;
    });
  }

  goToHf() {
    // this.events.sendSystemEvent({
    //   eventName: 'trending_fundraiser_healthfirst_click',
    // }).subscribe(_ => _);
    this.util.router.navigate(['healthfirst'], { queryParams: { utm_source: 'internal_Ketto', utm_medium: 'homepage', utm_content: 'trending_fundraiser' }, queryParamsHandling: 'merge' }).then(() => {
      this.util.scrollToTop();
    });
  }
}
